import FullnameTitleComponent from '72cms-ui/components/table-elements/FullnameTitleComponent';
import CustomFilterComponent from '72cms-ui/components/helpers/CustomFilterComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';

export default {
    fields: {
        firstname: {
            label: 'Name',
            component: FullnameTitleComponent,
        },
        email: {

        },
    },
    sortable: ['firstname', 'email'],
    filterable: [
        // 'customer_type'
    ],
    toolbar: [
        'create',
    ],
    customFilters: [],
    pagination: true,
    searchable: true,
    treeView: false,
    batchActions: [
        'delete', 'active',
    ],
    actions: [
        {
            name: 'edit',
            primary: true,
            component: 'edit-button',
        },
        {
            name: 'active',
            primary: true,
            component: ActiveSwitchActionComponent,
        },
        {
            name: 'delete',
            component: 'delete-button',
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.contacts.js